import * as Sentry from '@sentry/react';
import React from 'react';

import {Dims, Margin} from 'src/lib/commonTypes';

import VizErrorMessage from './VizErrorMessage';

type Props = {
  children: JSX.Element;
  dims: Dims;
  margin: Margin;
  context?: {[key: string]: any} | null;
  type?: 'border' | 'bg';
};

type State = {
  hasError: boolean;
};

export default class ErrorViz extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {hasError: false};
  }

  static getDerivedStateFromError(_: Error): State {
    return {hasError: true};
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    console.error(error, errorInfo);
    if (this.props.context) {
      Sentry.setContext('custom info', this.props.context);
    }
    Sentry.captureException(error);
  }

  render() {
    const {children, dims, margin, type = 'border'} = this.props;
    const {hasError} = this.state;
    let typeClassNames = '';
    if (type === 'border') {
      typeClassNames = 'border border-gray-500';
    } else if (type === 'bg') {
      typeClassNames = 'bg-gray-50';
    }

    return hasError ? (
      <div
        style={{
          paddingTop: margin.top,
          paddingRight: margin.right,
          paddingBottom: margin.bottom,
          paddingLeft: margin.left,
        }}
      >
        <div
          style={{
            width: dims[0] - margin.left - margin.right,
            height: dims[1] - margin.top - margin.bottom,
          }}
          className={`${typeClassNames} flex justify-center items-center`}
        >
          <VizErrorMessage />
        </div>
      </div>
    ) : (
      children
    );
  }
}
